import React, { ReactElement } from 'react';
import { Redirect, useHistory } from 'react-router-dom';
import { Button } from '@odin-labs/components';
import { AuthContext } from 'auth';
import { isContractorAdminPortal } from 'utils/contractorMemberUser';
import { classes } from './NotFoundContainer.style';

export function NotFoundContainer(): ReactElement {
  const history = useHistory();
  const { currentUser: user } = React.useContext(AuthContext);
  if (isContractorAdminPortal(user)) {
    return <Redirect to="/workers" />;
  }
  return (
    <div className={classes.container}>
      <div className={classes.containerContent}>
        <main className="sm:odin-flex">
          <p className="odin-text-4xl odin-font-extrabold odin-text-indigo-600 sm:odin-text-5xl">
            404
          </p>
          <div className="sm:odin-ml-6">
            <div className="sm:odin-border-l sm:odin-border-gray-200 sm:odin-pl-6">
              <h1 className="odin-text-4xl odin-font-extrabold odin-text-gray-900 odin-tracking-tight sm:odin-text-5xl">
                Page not found
              </h1>
              <p className="odin-mt-1 odin-text-base odin-text-gray-500">
                Please check the URL in the address bar and try again.
              </p>
            </div>
            <div className={classes.actionContent}>
              <Button
                text="Go back home"
                onClick={(): void => {
                  history.push('/');
                }}
              />
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
